import React, { Fragment,useState } from "react";
import './modal.css';
import Modal from "./Modal";
import useModal from './useModal';
import axios from 'axios';
import './contato.css';
import { FiLink } from 'react-icons/fi';
import './conta.css';
export default function Contato() {

    const { isShowing, toggle } = useModal();
    const [nome,setNome] = useState('');
    const [mensagem,setFeed] = useState('');
    const [email,setEmail] = useState('');

    function handleInputChangeName(event){
        setNome(event.target.value);
    }
    function handleInputChangesetFeed(event){
        setFeed(event.target.value);
    }
    function handleInputChangesetEmail(event){
        setEmail(event.target.value);
    }
      function createPost() {
        axios
          .post('http://localhost:3030/mensagem', {
            nome,
            mensagem,
          })
      }
      
      function handleFormSubmit(event){ 
        event.preventDefault();  
        console.log(nome, mensagem, email); 
        createPost()
      }
    return (
        <Fragment>
            <div className="container-global-contato">
                <div className="right-size">
                    <div className="area-input">
                        <div>
                            <FiLink size={24} color="#fff" />
                            <input
                                placeholder='Seu Nome'
                                required
                                id="nome"
                                nome="nome"
                                onChange={e =>handleInputChangeName(e)}
                            />
                        </div>
                    </div>
                    <div className="area-input">
                        <div>
                            <FiLink size={24} color="#fff" />
                            <input
                                placeholder='Seu feedback'
                                id="mensagem"
                                nome="mensagem"
                                required
                                onChange={e =>handleInputChangesetFeed(e)}
                            />
                        </div>
                    </div>
                    <div className="area-input">
                        <div>
                            <FiLink size={24} color="#fff" />
                            <input
                                placeholder='Seu Email'
                                id="email"
                                nome="email"
                                type="textarea"
                                required
                                onChange={e => handleInputChangesetEmail(e)}
                            />
                        </div>
                        <button onClick={(e)=> handleFormSubmit(e)}>
                            Enviar
                        </button>
                        <Modal
                            isShowing={isShowing}
                            hide={toggle}
                        />
                    </div>
                </div>
                <div className="left-size">
                    <div>
                        <span className="conteudo-endereco">
                            Email Contato:
                            <p>Emailteste@email.com.br</p><br />
                        </span>
                        <span className="conteudo-endereco">
                            Telefone:
                            <p>(45)3268-8745</p>
                        </span>
                    </div>
                    <div>
                        <span className="conteudo-endereco">
                            Endereço <br /><br />
                            <p>Rua Argentina, n°1510</p><br />
                            <p>Santa Helena Paraná</p><br />
                            <p>Centro</p><br />
                            <p>85892-000</p>
                        </span>
                    </div>

                </div>
            </div>
        </Fragment>
    )
}